export default {
  title: 'Organisation auswählen',
  form: {
    label: 'Ihre Organisationen',
    placeholder: 'Ihre Organisationen',
    continue: 'Auswählen',
  },
  back_to_login: 'Zurück zum Login',
  success: 'Organisation erfolgreich ausgewählt',
}
